export const contentTableConfig = {
  title: '三方电话资源统计',
  isAuto: true,
  propList: [
    { prop: 'thirdParty', label: '三方', minWidth: '100' },
    { prop: 'resourcesCount', label: '资源数', minWidth: '100' },
    { prop: 'repeatRate', label: '重复率', minWidth: '100', slotName: 'repeatRate' },
    { prop: 'repeatWithinSixMonthRate', label: '6个月内重复率', minWidth: '120', slotName: 'repeatWithinSixMonthRate' },
    { prop: 'deleteRate', label: '24小时删除率', minWidth: '120', slotName: 'deleteRate' },
    { prop: 'totalDeleteRate', label: '累计删除率', minWidth: '120', slotName: 'totalDeleteRate' },
    { prop: 'invalidNum', label: '重叠数', minWidth: '100' },
    { prop: 'thCount', label: '同行数', minWidth: '100' },
    { prop: 'openRate', label: '开口率', minWidth: '100', slotName: 'openRate' },
    { prop: 'lookRate', label: '看课率', minWidth: '100', slotName: 'lookRate' },
    { prop: 'dealCount', label: '成交资源数', minWidth: '120' },
    { prop: 'monthConversionRate', label: '当月转化率', minWidth: '120', slotName: 'monthConversionRate' },
    { prop: 'lastMonthConversionRate', label: '上月转化率', minWidth: '120', slotName: 'lastMonthConversionRate' },
    { prop: 'accConversionRate', label: '累积转化率', minWidth: '120', slotName: 'accConversionRate' }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
